<template>
    <v-container fluid>
        <v-card>
            <v-card-title class="pb-0">
                <v-row dense align="center">
                    <v-col cols="12" md="8">
                        <div class="text-subtitle-1 font-weight-bold">
                            <v-icon left color="primary">smart_display</v-icon>Videos y slider
                        </div>
                        <div class="text-caption grey--text text--darken-1">
                            Video del director en el inicio del participante, videos de felicitación al certificarse, promocionales
                            programados y el slider de imágenes del ingreso y el inicio.
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-tabs v-model="pestana" color="primary" class="mt-2">
                <v-tabs-slider></v-tabs-slider>
                <v-tab href="#videos"><v-icon small left>movie</v-icon> Videos</v-tab>
                <v-tab href="#estadisticas"><v-icon small left>insights</v-icon> Estadísticas</v-tab>
                <v-tab href="#slider"><v-icon small left>view_carousel</v-icon> Slider</v-tab>
            </v-tabs>
            <v-divider></v-divider>

            <v-tabs-items v-model="pestana" v-if="listo">
                <v-tab-item value="videos"><videos-lista/></v-tab-item>
                <v-tab-item value="estadisticas"><videos-estadisticas :activa="pestana === 'estadisticas'"/></v-tab-item>
                <v-tab-item value="slider"><videos-slider/></v-tab-item>
            </v-tabs-items>
        </v-card>
    </v-container>
</template>

<script>
import Auth from "@/services/auth";
import VideosLista from "./VideosLista.vue";
import VideosEstadisticas from "./VideosEstadisticas.vue";
import VideosSlider from "./VideosSlider.vue";

/** Panel "Videos y slider" (Administración → Videos y slider) con sus tres pestañas. */
export default {
    name: "AdministracionVideos",
    components: {VideosLista, VideosEstadisticas, VideosSlider},
    data() {
        return {
            pestana: "videos",
            listo: false,
        }
    },
    created() {
        Auth.checkPermisos("/administracion/videos").then(() => {
            this.listo = true;
        });
    },
}
</script>
